<template>
    <div class="navleft-db">
      <div class="navt">
        <div class="navttit">
          {{parentChannel.name}}
        </div>
        <ul class="navlist">
          <li v-for="(channel,index) in channelList" :key="index" :class="channel.isSelect==1?'cur':''"><a :href="gotoList(channel)">{{channel.name}}</a></li>
          <li v-for="n in 6" v-if="channelList.length==0"  ><a ></a></li>
        </ul>
      </div>
      <div class="navb">
        <div class="navbt">
          <span>科室导航</span>
          <a href="list?id=14" class="more floatR">更多>></a>
        </div>
        <div class="navbcont">
          <ul>
            <li v-for="(dept,index) in deptList"><a :href="gotoDept(dept)" >{{dept.name}}</a> </li>
            <li v-for="n in 12" v-if="deptList.length==0"><a  ></a> </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "tNavleft",
    data() {
      return {
        channelId: this.$route.query.id,
        archiveId:this.$route.query.aid,
        channelList: [],
        deptList: [],
        parentChannel:{},
      }
    },
    mounted() {
      this.initData();
    },
    methods: {
      initData: async function () {
        let res = await this.$getJSON('zyyarchives/leftNav', {channelId: this.channelId,archiveId: this.archiveId});
        if (res.code == 1) {
          this.channelList = res.data.channelList;
          this.deptList = res.data.deptList;
          this.parentChannel=res.data.parentChannel;
        }
      },
      //跳转到list列表
      gotoList:function (channel) {
        return channel.channel_url;
      },
      //跳转到科室列表
      gotoDept:function (dept) {
        return dept.channel_url;
      }

    }
  }
</script>

<style lang="scss">
.navleft-db{
  width: 220px;
  margin-left: 11px;
  float: left;
  .navt{
    margin-bottom: 60px;
    .navttit{
      width: 220px;
      height: 70px;
      background: url("../../images/zyy/leftt.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 70px;
      font-size: 24px;
      color: #fff;
      margin-bottom: 5px;
    }
    .navlist{
      li{
        width: 220px;
        height: 40px;
        color: #fff;
        line-height: 40px;
        background: url("../../images/zyy/leftc.png") no-repeat;
        background-size: 100%;
        margin-bottom: 5px;
        text-align: center;
        font-size: 16px;
        &.cur{
          background: url("../../images/zyy/cur.png") no-repeat;
          a{
            color: #fff;
          }
        }
        &:hover{
          background: url("../../images/zyy/cur.png") no-repeat;
          a{
            color: #fff;
          }
        }
      }
    }
  }
  .navb{
    width: 220px;
    border: 1px solid #ddd;
    .navbt{
      width: 100%;
      height: 47px;
      background: url("../../images/zyy/navbg.png") no-repeat;
      span{
        display: inline-block;
        background: #fff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        font-size: 18px;
        width: 100px;
        height: 44px;
        margin-left: 5px;
        line-height: 44px;
        margin-top: 3px;
        text-align: center;
      }
      .more{
        color: #fff;
        line-height: 45px;
        margin-right: 3px;
        font-size: 16px;
      }
    }
    .navbcont{
      ul{
        width: 220px;
        margin: 10px 0 5px;
        overflow: hidden;
        li{
          width: 107px;
          margin:2px 1px;
          height: 36px;
          background: url("../../images/zyy/fckbg.png") no-repeat;
          background-size: 100%;
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          float: left;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/navleft.vue